<div class="container-fluid d-flex flex-column">
    <app-common-header></app-common-header>
    <app-ag-grid 
      class=" d-flex flex-column position-relative h-100"
      [dataModel]="agGridDataModelListManager"
      (gridReady)="onGridReady($event)"
      (onPagination)="onPagination($event)"
      (onTextCellClick)="onTextCellClick($event)"
    ></app-ag-grid>
  </div>




  
  